module.exports = "<div class=\"container\">\n  \n    <a href=\"https://iod.eu.auth0.com/u/signup\">Bitte melden Sie sich über diesen Link an</a>\n  \n</div>\n"